// extracted by mini-css-extract-plugin
export default {"erorBlock":"Error_erorBlock__gp76a"};